export default function clearTimesout(id) {
  clearInterval(id);
}
